import axios from 'axios';
import { store } from './store/store';
import { errorToast } from './_helpers/utilities';

let API = process.env.REACT_APP_API_URL;

export const Instance = axios.create({
  baseURL: API,
});

Instance.defaults.headers.get['Accept'] = 'application/json';
Instance.defaults.headers.post['Accept'] = 'application/json';

Instance.interceptors.request.use(
  (request) => {
    request.headers['Authorization'] = 'Bearer ' + localStorage.getItem("token");
    // request.headers['Authorization'] = localStorage.getItem("token");
    return request;
  },
  (error) => {
    return error;
  }
);

Instance.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.code === "ERR_NETWORK") {
      errorToast("Network Issue Occurs")
      // localStorage.removeItem("token");
      // localStorage.removeItem("refreshToken");
      // store.dispatch({ type: "LOGOUT_SUCCESS" });
      // window.location.reload();
    } else if (error?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      store.dispatch({ type: "LOGOUT_SUCCESS" });
      window.location.reload();
    }
    return error;
  }
);